import React from 'react';
import PlayerRow from './PlayerRow';

const TopPlayersTable = ({ players, onPlayerClick }) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-700">
      <table className="w-full bg-gray-800">
        <thead className="bg-gray-900 border-b border-gray-700">
          <tr>
            <th className="px-4 py-3 text-center text-sm font-medium text-gray-400 uppercase tracking-wider">
              Rank
            </th>
            <th className="px-4 py-3 text-center text-sm font-medium text-gray-400 uppercase tracking-wider">
              Rating
            </th>
            <th className="px-4 py-3 text-left text-sm font-medium text-gray-400 uppercase tracking-wider">
              Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-medium text-gray-400 uppercase tracking-wider">
              Country
            </th>
            <th className="px-4 py-3 text-center text-sm font-medium text-gray-400 uppercase tracking-wider">
              Age
            </th>
            <th className="px-4 py-3 text-center text-sm font-medium text-gray-400 uppercase tracking-wider">
              Rank Δ
            </th>
            <th className="px-4 py-3 text-center text-sm font-medium text-gray-400 uppercase tracking-wider">
              Rating Δ
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-700">
          {players.length === 0 ? (
            <tr>
              <td colSpan="7" className="px-4 py-8 text-center text-gray-400">
                No players found matching your criteria
              </td>
            </tr>
          ) : (
            players.map((player, index) => (
              <PlayerRow
                key={player.id || index}
                player={player}
                rank={index + 1}
                onClick={() => onPlayerClick(player)}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TopPlayersTable;